export const getMetaTag = (metaHTML: string, name: string) => {
  const catchContent = new RegExp(
    'meta name="' + name + '" content="([^"]*)',
    'gi',
  )

  const result = metaHTML ? catchContent.exec(metaHTML)?.[1] : ''
  return result
}

const splitByTag = (
  html: string,
  startSearch: string,
  endSearches: string[],
) => {
  const continueIndex = html.indexOf(startSearch)
  const beforePart = html.substring(0, continueIndex)
  const foundEnds = endSearches.map((endSearch) => {
    return {
      index: html.indexOf(endSearch, continueIndex),
      length: endSearch.length,
    }
  })
  const foundEnd = foundEnds.find((foundEnd) => foundEnd.index > -1)
  if (!foundEnd) {
    return [beforePart, html.substring(continueIndex), '']
  } else {
    const finalEnd = foundEnd.index + foundEnd.length
    const continuePart = html.substring(continueIndex, finalEnd)
    const afterPart = html.substring(finalEnd)
    return [beforePart, continuePart, afterPart]
  }
}

export const splitHtml = (html: string) => {
  const splittedHtml: string[] = []
  let processingPart = html
  while (processingPart.indexOf('</p>') > -1) {
    let subPart = processingPart.substring(
      0,
      processingPart.indexOf('</p>') + 4,
    )
    const subPartLength = subPart.length

    let foundDiv = false
    const divSelectors = [
      '<div data-embed-type="affiliate',
      '<div data-embed-type="health-tool',
      '<div class="continue-reading-articles',
      '<div class="flat-after-first-paragraph',
    ]
    divSelectors.every((selector) => {
      if (subPart.indexOf(selector) > -1) {
        const [beforePart, continuePart, afterPart] = splitByTag(
          subPart,
          selector,
          ['</div>'],
        )
        splittedHtml.push(beforePart)
        splittedHtml.push(continuePart)
        splittedHtml.push(afterPart)
        foundDiv = true
        return false
      }
      return true
    })

    if (!foundDiv) {
      if (
        subPart.indexOf('<table') > -1 &&
        subPart.indexOf('</table') === -1 &&
        // make sure to have </table> before going into a loop
        processingPart.substring(subPartLength).includes('</table>')
      ) {
        subPart += processingPart.substring(
          subPartLength,
          processingPart.indexOf('</table>', subPartLength) + 8,
        )
        splittedHtml.push(subPart)
      } else if (
        subPart.indexOf('<ul') > -1 &&
        subPart.indexOf('</ul') === -1 &&
        // make sure to have </table> before going into a loop
        processingPart.substring(subPartLength).includes('</ul>')
      ) {
        subPart += processingPart.substring(
          subPartLength,
          processingPart.indexOf('</ul>', subPartLength) + 5,
        )
        splittedHtml.push(subPart)
      } else {
        splittedHtml.push(subPart)
      }
    }
    processingPart = processingPart.substring(subPart.length)
  }
  if (processingPart) {
    splittedHtml.push(processingPart)
  }
  return splittedHtml.filter((s) => !!s.trim())
}

export const splitHtml2 = (html: string) => {
  const splittedHtml: string[] = []
  const splittedTag = splitSpecialTag(html)
  splittedHtml.push(...splittedTag)
  return splittedHtml.filter((s) => !!s.trim())
}

const divSelectors = [
  { identifier: '<div data-embed-type="', ends: ['</div>', '/>', '>'] },
  {
    identifier: '<div class="continue-reading-articles',
    ends: ['</div>', '/>', '>'],
  },
  {
    identifier: '<div class="flat-after-first-paragraph',
    ends: ['</div>', '/>', '>'],
  },
  {
    identifier: '<div class="percentages-',
    ends: ['</div>', '/>', '>'],
  },
  // {
  //   identifier: '<table',
  //   ends: ['</table>'],
  // },
  // {
  //   identifier: '<ul',
  //   ends: ['</ul>'],
  // },
  {
    identifier: '[article-yoast-faqs',
    ends: [']'],
  },
  { identifier: '[embed-health-tool', ends: [']'] },
]
const splitSpecialTag = (s: string) => {
  const res: string[] = []
  if (s)
    divSelectors.every((selector) => {
      if (s.indexOf(selector.identifier) > -1) {
        const [beforePart, continuePart, afterPart] = splitByTag(
          s,
          selector.identifier,
          selector.ends,
        )
        res.push(...splitSpecialTag(beforePart))
        res.push(continuePart)
        res.push(...splitSpecialTag(afterPart))
        return false
      }
      return true
    })
  if (!res.length) {
    res.push(s)
  }
  return res
}
